// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","image":"Logo_image__H9SdG","logoText":"Logo_logoText__4IH4S"};